<template>
  <div class="mini-cart">
    <div class="utility-nav__dropdown-header flex flex--align-center">
      <h3 class="type-h4 align-center no-bottom-margin">My Order</h3>
    </div>
    <table class="mini-cart width-100-full">
      <tfoot class="cart-footer__subtotal type-circular bg-color-off-white">
        <tr v-if="TotalProducts > 0">
          <td class="cart-footer__subtotal--amount" colspan="2">
            <h5 class="type-h4 no-bottom-margin">Subtotal:</h5>
          </td>
          <td class="cart-footer__subtotal--amount" colspan="2">
            <span class="type-h4 float-r color-primary no-bottom-margin">{{
              cartPriceTotal
            }}</span>
          </td>
        </tr>
        <tr v-else>
          <td class="cart-footer__subtotal--amount" colspan="2">
            <p
              class="align-center type-circular no-bottom-margin type-notransform"
            >
              You currently have no items in your cart.
            </p>
          </td>
        </tr>
        <tr>
          <!-- TODO: Check if they are a guest -->
          <td class="cart-footer__subtotal--checkout" colspan="4">
            <a href="/cart/" class="btn">Continue to Cart</a>
          </td>
        </tr>
      </tfoot>
      <tbody>
        <CartItem
          v-for="item in reversedItems"
          :cartItemData="item"
          :isMiniCart="true"
          :key="item.Id"
        >
        </CartItem>
      </tbody>
    </table>
  </div>
</template>

<script>
import CartItem from "./CartItem.vue";
import axios from "axios";

import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapState } from "vuex";

import { FETCH_CART_DATA } from "../vuex/modules/cart/mutations";
import { RECALCULATE_TOTALS } from "../vuex/modules/cart/mutations";
import { SET_PRODUCT_PRICES } from "../vuex/modules/cart/mutations";

export default {
  name: "MiniCart",
  components: {
    CartItem,
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("setEndpoint");
    const $vm = this;
    // make this async?
    this.FETCH_CART_DATA();
    // .then( function(){
    // 	console.log('promise returned with cart data');
    // 	// $vm.SET_PRODUCT_PRICES();
    // });
  },

  watch: {
    // we use a watcher to detect a change on whether the user
    // is logged in or not. The cart data needs to reflect this.
    isLoggedIn() {
      this.FETCH_CART_DATA();
    },
  },

  methods: {
    ...mapActions({
      FETCH_CART_DATA,
      // UPDATE_CART_QUANTITY,
      RECALCULATE_TOTALS,
      SET_PRODUCT_PRICES,
    }),

    handleSubmit() {
      // console.log('submit cart');
    },
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.AuthStore.isLoggedIn,
      Items: (state) => state.cartStore.Items,
      SubTotal: (state) => state.cartStore.SubTotal,
      TotalProducts: (state) => state.cartStore.TotalProducts,
      AllProductIds: (state) => state.cartStore.AllProductIds,
    }),
    ...mapGetters(["totalItemsInCart", "cartPriceTotal", "reversedItems"]),
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MiniCart.vue